var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('ActionsButtons',{staticClass:"hidden-sm-and-down",attrs:{"actions":_vm.a}}),_c('ActionsDropdown',{staticClass:"hidden-md-and-up",attrs:{"actions":_vm.a}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }